var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.ticketsData,"sort-by":"used","sort-desc":"","mustSort":"","avatar":"name"},scopedSlots:_vm._u([{key:"item.tenantId",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.getTenantName(item)))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }